exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-bar__progress-bar__1h675{position:relative;width:100%;height:100%}.progress-bar__progress-bar--vertical__aTQyc .progress-bar__progress-bar__fill__1dYUM{width:100%}.progress-bar__progress-bar--vertical__aTQyc .progress-bar__progress-bar__input__2wcj2{-webkit-appearance:slider-vertical;-ms-writing-mode:bt-lr}.progress-bar__progress-bar--horizontal__169nR .progress-bar__progress-bar__fill__1dYUM{height:100%}.progress-bar__progress-bar__fill__1dYUM{position:absolute;bottom:0;left:0;background-color:hsla(0,0%,100%,.9)}.progress-bar__progress-bar__input__2wcj2{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;padding:0;margin:0;border:0;cursor:pointer;outline:none;opacity:0}", ""]);

// exports
exports.locals = {
	"progress-bar": "progress-bar__progress-bar__1h675",
	"progressBar": "progress-bar__progress-bar__1h675",
	"progress-bar--vertical": "progress-bar__progress-bar--vertical__aTQyc",
	"progressBarVertical": "progress-bar__progress-bar--vertical__aTQyc",
	"progress-bar__fill": "progress-bar__progress-bar__fill__1dYUM",
	"progressBarFill": "progress-bar__progress-bar__fill__1dYUM",
	"progress-bar__input": "progress-bar__progress-bar__input__2wcj2",
	"progressBarInput": "progress-bar__progress-bar__input__2wcj2",
	"progress-bar--horizontal": "progress-bar__progress-bar--horizontal__169nR",
	"progressBarHorizontal": "progress-bar__progress-bar--horizontal__169nR"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/progress-bar/progress-bar.styl
// module id = 1315
// module chunks = 0 1 2 3